import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="content">
        <h1 className="glitch" data-text="404">404</h1>
        <h4>Oops! Page not found</h4>
        <p>Why did the web developer go broke? Because he used up all his cache!</p>
        <Link to="/" className="home-link">
          Go back to the homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;